module.exports = __webpack_public_path__ + "static/media/photo3.43e0d3df.png";